import createPersistedStore from './configureStore';

export const { store, persistor, history } = createPersistedStore();
